import React from 'react';
import {
  // Base components
  Create,
  Edit,
  SimpleForm,
  List,
  Datagrid,
  EditButton,
  // Input components
  TextInput,
  NumberInput,
  BooleanInput,
  ReferenceInput,
  SelectInput,
  // Field components
  TextField,
  ImageField,
  // Actions
  ListButton,
  RefreshButton,

  translate as t,
  required,
} from 'admin-on-rest';
import { CardActions } from 'material-ui';
import ImageInputCustom from '../components/inputs/ImageInput';
import CheckpointListBuilder from '../components/Quiz/CheckpointListBuilder';
import DeleteButton from '../components/button/DeleteButton';

const QuizTitle = ({ record }) => (
  <span>Quiz: {`"${record && record.internalTitle}"`}</span>
);

export const QuizList = t((props) => (
  <List {...props}>
    <Datagrid>
      <TextField source="internalTitle" label={props.translate('title')} />
      <TextField source="category" label={props.translate('category')} />
      <TextField source="languageCode" label={props.translate('languageCode')} />
      <EditButton {...props} basePath="/quizes" />
    </Datagrid>
  </List>
));

export const QuizCreate = t((props) => {
  const defaultValues = {
    prio: 1,
    active: false,
  };
  return (
    <Create {...props}>
      <SimpleForm defaultValue={defaultValues}>
        <SelectInput
          validate={[required]}
          source="category"
          choices={[
            { id: 'pinchoversity', name: 'Pinchoversity' },
            { id: 'onboarding', name: 'Onboarding' },
          ]}
        />
        <TextInput source="internalTitle" validate={[required]} />
        <NumberInput source="prio" validate={[required]} />
        <TextInput className="use-default" source="description" validate={[required]} />
        <TextInput source="buttonText" validate={[required]} />
        <BooleanInput source="active" validate={[required]} />
        <SelectInput
          validate={[required]}
          source="languageCode"
          choices={[
            { id: 'sv', name: props.translate('languages.sv') },
            { id: 'en', name: props.translate('languages.en') },
          ]}
        />
        <ReferenceInput source="market" reference="markets" allowEmpty>
          <SelectInput optionText="countryCode" optionValue="_id" />
        </ReferenceInput>
        <ImageInputCustom
          labelSingle="resources.quizes.promoUpload"
          source="promoImage.image"
          accept="image/*"
        >
          <ImageField source="src" />
        </ImageInputCustom>
        <TextInput source="promoImage.alt" validate={[required]} />
        <CheckpointListBuilder />
      </SimpleForm>
    </Create>
  );
});

const QuizEditActions = (props) => {
  const style = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
  };
  return (
    <CardActions style={style}>
      <RefreshButton />
      <ListButton basePath={props.basePath} />
      <DeleteButton {...props} record={props.data} resource="quizes" />
    </CardActions>
  );
};

export const QuizEdit = t((props) => (
  <Edit title={<QuizTitle />} actions={<QuizEditActions {...props} />} {...props}>
    <SimpleForm>
      <SelectInput
        validate={[required]}
        source="category"
        choices={[
          { id: 'pinchoversity', name: 'Pinchoversity' },
          { id: 'onboarding', name: 'Onboarding' },
        ]}
      />
      <TextInput source="internalTitle" validate={[required]} />
      <NumberInput source="prio" validate={[required]} />
      <TextInput source="description" validate={[required]} />
      <TextInput source="buttonText" validate={[required]} />
      <BooleanInput source="active" validate={[required]} />
      <SelectInput
        validate={[required]}
        source="languageCode"
        choices={[
          { id: 'sv', name: props.translate('languages.sv') },
          { id: 'en', name: props.translate('languages.en') },
        ]}
      />
      <ReferenceInput source="market" reference="markets" allowEmpty>
        <SelectInput optionText="countryCode" optionValue="_id" />
      </ReferenceInput>
      <ImageInputCustom
        labelSingle="resources.quizes.promoUpload"
        source="promoImage.image"
        accept="image/*"
      >
        <ImageField source="src" />
      </ImageInputCustom>
      <TextInput source="promoImage.alt" validate={[required]} />
      <CheckpointListBuilder />
    </SimpleForm>
  </Edit>
));
